// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { getDealer } from '../../shared/repositories';
import { handleError } from '../../../../sharedmodules/services/error-handlers';

export const readDealer = (getAccessToken, account) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        if (account) {

            const dealer = await getDealer(getAccessToken, account);

            dispatch({
                dealer,
                type: actions.UPDATE_NEW_TRANSFER_NEW_DEALER,
            });

        }

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
